import { Tooltip } from "antd";
import React from "react";
import Avatar from "react-avatar";
import "./styles.less";

interface IUserAvatarProps {
  url: string;
  name: string;
  size: number;
}

const UserAvatar: React.FC<IUserAvatarProps> = ({ url, name, size }) => {
  return url ? (
    <Tooltip title={name}>
      <img
        src={url}
        alt={name}
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
        }}
      />
    </Tooltip>
  ) : (
    <Avatar
      name={name}
      round
      size={`${size}px`}
      maxInitials={2}
      className="avatar-placeholder"
    />
  );
};

export default UserAvatar;
